import React from 'react';
import glamorous from 'glamorous';
import Modal from 'react-bootstrap/lib/Modal';
import { get, find, isEmpty } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { withStateHandlers } from 'recompose';
import { hashHistory } from 'react-router';

import ChartTopBar from './chart-top-bar';
import BarChart from './bar-chart';
import PieChart from './pie-chart';
import WordCloud from './word-cloud';
import WorldMap from './world-map';

import { CHART_TYPES } from '../constants';

const CHART_COMPONENTS_BY_TYPE = {
  [CHART_TYPES.BAR_CHART]: BarChart,
  [CHART_TYPES.PIE_CHART]: PieChart,
  [CHART_TYPES.WORD_CLOUD]: WordCloud,
  [CHART_TYPES.WORLD_MAP]: WorldMap,
};

const Chart = (props) => {
  const { chartType, dataset } = props;

  const hasNoDataToShow = isEmpty(dataset) || isEmpty(dataset.data);
  if (hasNoDataToShow) {
    return (
      <glamorous.Div
        css={{
          height: 400,
          width: '100% !important',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#eee',
          textTransform: 'uppercase',
          fontWeight: 'bold',
        }}
      >
        <FormattedMessage id="common.noData" />
      </glamorous.Div>
    );
  }

  const ChartComponent = get(CHART_COMPONENTS_BY_TYPE, chartType, <div />);
  return <ChartComponent {...props} />;
};

const ChartContainer = (props) => {
  const {
    datasets,
    label,
    selectedChartType,
    selectedDatasetId,
    isFullScreen,
    setIsFullScreen,
    goToSearchPage,
  } = props;

  const selectedDataset = find(datasets, { id: selectedDatasetId });

  if (isFullScreen) {
    return (
      <Modal
        show
        dialogClassName="chart-fullscreen-modal"
        onHide={e => setIsFullScreen(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {label}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Chart
            chartType={selectedChartType}
            dataset={selectedDataset}
            goToSearchPage={goToSearchPage}
            isFullScreen
          />
        </Modal.Body>
      </Modal>
    );
  }

  return (
    <glamorous.Div
      className="row"
      css={{ marginTop: 40 }}
    >
      <div className="col-md-12">
        <ChartTopBar {...props} setIsFullScreen={setIsFullScreen} />
        <Chart
          chartType={selectedChartType}
          dataset={selectedDataset}
          goToSearchPage={goToSearchPage}
        />
      </div>
    </glamorous.Div>
  );
};

const withChartState = withStateHandlers((props) => {
    const { datasets, chartTypes, yearsRange } = props;
    return {
      selectedDatasetId: get(datasets, '[0].id'),
      selectedChartType: get(chartTypes, '[0]'),
      isFullScreen: false,
      yearsRange,
    };
  },
  {
    onDatasetChange: () => (e) => ({ selectedDatasetId: e.target.value }),
    onChartTypeChange: () => (e) => ({ selectedChartType: e.target.value }),
    setIsFullScreen: () => (isFullScreen) => ({ isFullScreen }),
    goToSearchPage: ({ yearsRange }) => (searchParams, intl) => {
      if (searchParams) {
        const nextQuery = { ...searchParams };

        const startYear = get(yearsRange, '[0]');
        if (startYear) nextQuery.startDate = `${startYear}-01-01`;

        const endYear = get(yearsRange, '[1]');
        if (endYear) nextQuery.endDate = `${endYear}-12-31`;

        if (intl.locale && intl.locale !== 'en') nextQuery.lang = intl.locale;

        hashHistory.push({ query: nextQuery });
      }
    },
  });

export default withChartState(ChartContainer);



// WEBPACK FOOTER //
// ./src/views/dashboard/chart/index.js